import _styled, { default as _styled2 } from "styled-components";
const _excluded = ["style", "className", "size", "color"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { BADGE_SIZES, BADGE_COLORS } from '../consts';

/**
 * Dot Badge.
 */

const DotBadge = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      size = BADGE_SIZES.MEDIUM,
      color = BADGE_COLORS.DEFAULT
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css: [{
      backgroundColor: color,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }, variantSwitch({
      statement: size,
      variants: {
        [BADGE_SIZES.SMALL]: {
          minHeight: 8,
          minWidth: 8,
          height: 8,
          width: 8,
          maxHeight: 8,
          maxWidth: 8,
          borderRadius: theme.borderRadius.medium
        },
        [BADGE_SIZES.MEDIUM]: {
          minHeight: 16,
          minWidth: 16,
          height: 16,
          width: 16,
          maxHeight: 16,
          maxWidth: 16,
          borderRadius: theme.borderRadius.large
        }
      }
    }), style]
  }), size === BADGE_SIZES.MEDIUM && /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      backgroundColor: theme.tokens.colors.background.primary.value,
      minHeight: 6,
      minWidth: 6,
      height: 6,
      width: 6,
      maxHeight: 6,
      maxWidth: 6,
      borderRadius: 3
    }]
  }));
});
DotBadge.displayName = 'DotBadge';
DotBadge.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Badge size, defaults to 'medium' */
  size: PropTypes.oneOf(Object.values(BADGE_SIZES)),
  /** Color to apply on the background of the Badge */
  color: PropTypes.string
};
export default DotBadge;
var _StyledDiv = _styled("div")`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  displayName: "DotBadge___StyledDiv2",
  componentId: "sc-y0k9i7-0"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=DotBadge.js.map